// config
import axios, { handleResp } from '../config/axios';

export const getDashboard = async () => {
    try {
        let respData = await axios({
            url: `/admin/dashboard`,
            method: 'get'
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const getChildNode = async (userId) => {
    try {
        let respData = await axios({
            url: `/admin/tree/${userId}`,
            method: 'get'
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const getTreeInfo = async (userId) => {
    try {
        let respData = await axios({
            url: `/admin/tree-info/${userId}`,
            method: 'get'
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};


export const changePassword = async (data) => {
    try {
        let respData = await axios({
            url: `/admin/change-password`,
            method: 'post',
            data
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const getUserList = async (params) => {
    try {
        let respData = await axios({
            url: `/admin/user-list`,
            method: 'get',
            params
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const getPinList = async (params) => {
    try {
        let respData = await axios({
            url: `/admin/pin-list`,
            method: 'get',
            params
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const getPinLogList = async (params, pinId) => {
    try {
        let respData = await axios({
            url: `/admin/pin-log-list/${pinId}`,
            method: 'get',
            params
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const getBonusHistory = async (params) => {
    try {
        let respData = await axios({
            url: `/admin/bonus-history`,
            method: 'get',
            params
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const getWithdrawHistory = async (params) => {
    try {
        let respData = await axios({
            url: `/admin/withdraw`,
            method: 'get',
            params
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const getContactList = async (params) => {
    try {
        let respData = await axios({
            url: `/admin/contact`,
            method: 'get',
            params
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const pinGenerate = async (data) => {
    try {
        let respData = await axios({
            url: `/admin/pin-generate`,
            method: 'post',
            data
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const pinAssign = async (data) => {
    try {
        let respData = await axios({
            url: `/admin/pin-assign`,
            method: 'post',
            data
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const createManualUser = async (data) => {
    try {
        let respData = await axios({
            url: `/admin/create-user`,
            method: 'post',
            data
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const editUser = async (data) => {
    try {
        let respData = await axios({
            url: `/admin/edit-user`,
            method: 'post',
            data
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const getBankDetails = async (userId) => {
    try {
        let respData = await axios({
            url: `/admin/bank-details/${userId}`,
            method: 'get'
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const withdrawApprove = async (data) => {
    try {
        let respData = await axios({
            url: `/admin/withdraw`,
            method: 'post',
            data
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const updateBankDetails = async (data, userId) => {
    try {
        let respData = await axios({
            url: `/admin/bank-details/${userId}`,
            method: 'post',
            data
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};